import React, { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useHistory } from "react-router";
import { AuthContext } from "../context/AuthContext";
import firebase from "firebase/app";
import getUserById from "../requests/getUserById";
import getTourById from "../requests/getTourById";
import deleteUserRole from "../requests/deleteUserRole";

const ConfirmUserRoleDeletion = () => {
  const history = useHistory();
  const { user, setUser } = useContext(AuthContext);
  const [ token, setToken ] = useState("");
  const [ userRoleEmail, setUserRoleEmail ] = useState("");
  const [ tourName, setTourName ] = useState("");
  const [ owners, setOwners ] = useState([]);

  const { tourId, userId } = useParams();

  firebase.auth().onAuthStateChanged(function(firebaseUser) {
    if (firebaseUser) {
      setUser(firebaseUser);
      firebaseUser.getIdToken().then(token => {
        setToken(token);
        // console.log("JWT:", token);
      })
    } else {
      history.push("/login");
    }
  });

  useEffect(() => {
    if (token) {
      getUserById(token, userId).then(response => {
        // console.log(response.data);
        if (response.status === 200) {
          setUserRoleEmail(response.data[0].email);
        }
      });
    }
  }, [token, userId]);

  useEffect(() => {
    if (token) {
      getTourById(token, tourId).then(response => {
        // console.log(response.data);
        if (response.status === 200) {
          setTourName(response.data[0].name);
          setOwners(response.data[0].owners)
        }
      });
    }
  }, [token, tourId]);

  const handleDeleteUserRole = (event) => {
    if (token) {
      deleteUserRole(token, tourId, userId)
        .then((response) => {
          if (response.status === 204) {
            history.push(`/tour/${tourId}/users`)
          }
        });
    }
  };

  if (owners.includes(user.uid)) {
    return (
      <div className="container center">
        <div className="confirm-delete">
          <h2 className="heading">Confirm deletion</h2>
          <h3>You have chosen to delete this User's roles:</h3>
          <article className="toBeDeleted">
            <p>User: <strong>{userRoleEmail}</strong></p>
            <p>Tour: <strong>{tourName}</strong></p>
          </article>
          
          <p>All of the User's roles in relation to the Tour shown above will be removed.</p>
          <p>If you want to reduce the User's role (eg. from Editor to Viewer), continue with this process and then add the User again with the reduced role.</p>
          <div>
            <p><Link to={`/tour/${tourId}/users`} className="button-link">Take me back to the Tour Users page</Link></p>
            <button
              type="button"
              className="form-button center"
              onClick={handleDeleteUserRole}
            >
              Confirm deletion of {userRoleEmail}
            </button>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="container">
        <div className="unauthorised-deletion">
          <h2 className="heading">Unauthorised</h2>
          <p>You appear not to be authorised to delete this User.</p>
          <p>If you arrived here by clicking a link on the Tour Users page then something went wrong between leaving that page and arriving here. Perhaps <Link to={`/tour/${tourId}/users`}>go back</Link> and try again.</p>
          <p>If you found your way here by some other means then you're wasting your time.</p>
          
        </div>
      </div>
    )
  }

};

export default ConfirmUserRoleDeletion;
